
export enum BasketItemType
{
    Unset = "Unset",
    Rent = "Rent",
    Sale = "Sale"
}

export const BasketItemTypeLabels = {
    [BasketItemType.Unset]: "Nieznany",
    [BasketItemType.Rent]: "Wynajem",
    [BasketItemType.Sale]: "Sprzedaż",
}